"use client";
import { jsx as r } from "react/jsx-runtime";
import { css as s } from "@emotion/react";
import f from "@emotion/styled";
import { SPACINGS as a } from "../../tokens/spacings/Spacings.js";
import { forwardRef as p } from "react";
const x = p(
  ({ children: o, ...t }, e) => /* @__PURE__ */ r(d, { ...t, "data-comp": "flexbox", ref: e, children: o })
);
x.displayName = "Flexbox";
const F = x, d = f.div(
  ({
    feAlignItems: o,
    feFlexDirection: t,
    feFlexWrap: e,
    feGap: l,
    feJustifyContent: i,
    feStretch: m
  }) => s`
		align-items: ${o};
		display: flex;
		flex-flow: ${t} ${e};
		gap: ${l && a[l]};
		height: ${m && "100%"};
		justify-content: ${i};
	`
);
export {
  F as default
};
